import React from 'react';
import { useSelector } from 'react-redux';
import Icons from 'consts/icons';
import Fade from '@material-ui/core/Fade';
import ComponentSettings from 'components/user/settings/UserSettings/ComponentSettings';
import ExistingUsers from 'components/user/admin/users/ExistingUsers';
import Organizations from 'components/user/admin/organizations/Organizations';
import SystemSettings from 'components/user/admin/systemSettings/Main';
import Subscriptions from 'components/user/admin/subscriptions/Main';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { GROUP_TYPES } from 'consts/config';
import { SidebarMenuDetailsUseStyles } from './SidebarMenuDetailsUseStyles';

const SidebarMenuAdminDetails = () => {
  const [items, setItems] = React.useState([]);
  const [details, setDetails] = React.useState(null);
  const classes = SidebarMenuDetailsUseStyles();
  const userGroups = UserSessionDataHandler.getUserDataObject().group;

  const toggleModal = () => {
    if (details) setDetails(null);
  };

  const useString = () => {
    const lang = useSelector(state => state.language);

    return lang;
  };
  const subtitles = useString().sidebar.admin;

  React.useEffect(() => {
    setItems([
      {
        name: 'organizations',
        icon: <Icons.Misc.Organization />,
        url: <Organizations />,
      },
      {
        name: 'users',
        icon: <Icons.Misc.User />,
        url: <ExistingUsers />,
      },
      {
        name: 'systemSettings',
        icon: <Icons.Misc.SystemSettings />,
        url: <SystemSettings />,
      },
      {
        name: 'subscriptions',
        icon: <Icons.Misc.Loyalty />,
        url: <Subscriptions />,
      },
    ]);
  }, []);

  return (
    <>
      <div className={`${classes.SidebarMenuDetails}__table`}>
        {items.map(item =>
          item.name !== 'systemSettings' ||
          (item.name === 'systemSettings' &&
            userGroups.includes(GROUP_TYPES.admin)) ? (
            <div
              key={item.name}
              className={`${classes.SidebarMenuDetails}__list`}
            >
              <div
                key={item.name}
                className={`${classes.SidebarMenuDetails}__list__item ${
                  details === item.name ? 'active' : ''
                }`}
                onClick={
                  () => setDetails(details !== item.name ? item.name : null)
                  // eslint-disable-next-line react/jsx-curly-newline
                }
                aria-hidden="true"
              >
                <div
                  className={`${classes.SidebarMenuDetails}__list__item__icon`}
                >
                  {item.icon}
                </div>
                <span
                  className={`${classes.SidebarMenuDetails}__list__item__text`}
                >
                  {subtitles[`${item.name}_`]}
                </span>
              </div>
            </div>
          ) : null
        )}
      </div>
      <Fade in={details !== null} timeout={700}>
        <div>
          <ComponentSettings
            details={details}
            setDetails={setDetails}
            items={items}
            toggleModal={toggleModal}
          />
        </div>
      </Fade>
    </>
  );
};

export default SidebarMenuAdminDetails;
